import { useMediaQuery } from '@material-ui/core';

import { TopBar, TopBarMobile } from '../componenets';

const style = {
    AccessibilityWrapper: { marginTop: "9vh", padding: "0 2vw" },
    AccessibilityContent: { textAlign: "start" }
}

const Accessibility = () => {

    const isMobile = useMediaQuery('(max-width: 600px)');

    return (
        <div>
            {isMobile ? <TopBarMobile /> : <TopBar accessibility={true} />}
            <div style={style.AccessibilityWrapper}>
                <span style={{ textAlign: "start" }}>
                    <h2>הצהרת נגישות</h2>
                    <p>  התאמות הנגישות של החברה בוצעו עפ״י המלצות התקן הישראלי (ת״י 5568) לנגישות תכנים באינטרנט ברמת AA וכן עפ״י מסמך 2.0 WCAG הבינלאומי.<br />
                        במקומות בהם התקן לא התאים בוצעו התאמות נגישות בהתאם ליכולות הנגישות של מערכת ההפעלה.</p>

                    <p>הבדיקות נבחנו לתאימות הגבוהה ביותר עבור דפדפנים Chrome ו- Firefox.</p>

                    <p>האתר מספק מבנה סמנטי עבור טכנולוגיות מסייעות ותמיכה בדפוס השימוש המקובל להפעלה עם מקלדת בעזרת מקשי החיצים, Enter ו- Esc ליציאה מתפריטים וחלונות.</p>

                    <p>מורה להחלפה ממשיכים כל העת לשפר את השרות הניתן לאנשים עם מוגבלות. אם נתקלתם בשירות לא נגיש או בכל שאלה ו/או הצעה בנושא, אנא פנו אלינו במייל moralhahlafa@gmail.com </p>

                </span>

            </div >
        </div>
    )
}
export default Accessibility